export class ProductCode {
  public static PremiumDigitalMember = ['PremiumDigitalMember'];
  public static QAMember1 = ['QAMember1'];
  public static FourteenDigitalMember = ['14DigitalMember'];
  public static DigitalMemberProductCodes = ['14DigitalMember', 'PremiumDigitalMember'];
}
